module.exports = __webpack_public_path__ + "img/company5-1.2d760eed.png";